import React, { useMemo } from 'react';

import { Props } from './AppContext.interface';

export const AppContext = React.createContext({});

export const AppContextWrapper = ({ children }: Props): React.JSX.Element => {
  const value = useMemo(
    () => ({
      actions: {}
    }),
    []
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppContextWrapper;
